module.exports = __webpack_public_path__ + "img/Slajd13.60ff6f20.jpeg";